export default __webpack_public_path__ + "static/menu-nikugatou-min-15c833db592437b444ff78ccda2d8807.jpg";